import NotificationsUnread from './NotificationsUnread.vue';

export default NotificationsUnread;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/notification/views/unread/index.ts